import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  orderWithinFromModel,
  validateOrderWithinCondition,
  type OrderWithinState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const ORDER_WITHIN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderWithinState>>,
): ConditionType<OrderWithinState, Condition.OrderWithin> => ({
  name: "Time since order",
  description(state) {
    return `Within ${+state} days of order`;
  },
  Details(props: ConditionTypeDetailsProps<OrderWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return orderWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.ORDER_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return validateOrderWithinCondition(state).valid;
  },
});

export { type OrderWithinState } from "@redotech/redo-model/return-flow/condition-validate";
